import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
// import menus from './menus'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    expired: 60, // in minutes
    user: {},
    query: '',
    menu: [],
    customer: {},
    groupon: {},
    wxReady: false,
    wxToken: {},
    location: { lon: '', lat: '' }
  },
  mutations,
  actions
})
